import { render } from "./image.vue?vue&type=template&id=19ebe0d6"
const script = {}
script.render = render

export default script